module.exports = __webpack_public_path__ + "img/pricing-tree-1.fd3111dc.png";